/**
 * Default timeout value (in milliseconds) for loading the Instana EUM script.
 * This constant is used as a fallback when scriptLoadTimeout is not provided in the configuration.
 */
export const DEFAULT_SCRIPT_LOAD_TIMEOUT_MS = 10000;
